// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"vm-z","badgeLink":"wm-z","category":"xm-z"};